var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"slot":"activator","icon":""},slot:"activator"},'v-btn',_vm.btnProps,false),on),[_c('v-icon',[_vm._v("mdi-dialpad")])],1)]}}])},[_c('v-card',[_c('dialer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }